<script setup lang="ts">
import {computed} from "vue";

interface Item {
    value: any,
    label: string,
    description: string,
    icon: string
}

interface Props {
    modelValue: any,
    items: Array<Item>
}
const props = defineProps<Props>()
const emit = defineEmits(['update:modelValue', 'change'])
const value = computed({
    get() {
        return props.modelValue
    },
    set(value) {
        emit('update:modelValue', value)
    }
})
</script>

<template>
    <v-radio-group
        v-model="value"
        class="py-0 mt-4"
        density="compact"
        rounded="lg"
        hide-details
        @change="$emit('change', value)"
    >
        <v-radio
            v-for="(item, key) in props.items"
            :key="key"
            :value="item.value"
            class="my-0"
            color="blue"
        >
            <template #label>
                <v-list-item density="comfortable">
                    <template #prepend>
                        <v-avatar>
                            <v-icon color="black">
                                {{ item.icon }}
                            </v-icon>
                        </v-avatar>
                    </template>
                    <v-list-item-title class="text-body-2 font-weight-bold text-black">
                        {{ item.label }}
                    </v-list-item-title>
                    <v-list-item-subtitle
                        class="text-caption font-weight-regular text-body-2"
                    >
                        {{ item.description }}
                    </v-list-item-subtitle>
                </v-list-item>
            </template>
        </v-radio>
    </v-radio-group>
</template>

<style scoped>

</style>
